import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/parts/global/ContactForm.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/parts/global/ModalVideoFromImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResourcesBlock"] */ "/opt/buildhome/repo/src/app/parts/global/ResourcesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MouthpiecesWrapperBlock"] */ "/opt/buildhome/repo/src/app/parts/product-detail/MouthpiecesWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/parts/product/ProductHorizCards.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/parts/testimonials/Testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/Accordion/Accordion.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Accordion/AccordionController.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/BaseSlider/BaseSlider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Controls/DropDown/DropDown.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Controls/Select/Select.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Events/Events.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/IlluminatedImage/IlluminatedImage.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/IlluminatedImage/IlluminatedImageBase.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/IlluminatedImage/IlluminationHandle.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ImageGallery/ImageGalleryProcessor.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Layout/Styles/fixed-ratio-box.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Layout/Styles/height.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Layout/Styles/margin.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Layout/Styles/padding.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Layout/Styles/width.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/MainMenu/MainMenuController.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ObfuscatedEmail/ObfuscatedEmail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ObfuscatedEmailClient"] */ "/opt/buildhome/repo/src/components/ObfuscatedEmail/ObfuscatedEmailClient.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Page/page.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Page/PageContentToClipboard.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Reveal/FadeIn.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ScrollTo/ScrollToController.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Typography/Styles/color.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Typography/Styles/typography.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/CaptionedImage/captioned-image.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Card/card.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ImageCard/image-card.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Container/container.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ImageGallery/image-gallery.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ImageReference/image-reference.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/MainMenu/main-menu.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Product/product.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Progress/progress.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/SideBySideText/side-by-side-text.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/TextRow/text-row.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Patent/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Video/CustomVimeoPlayer.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Video/InplaceVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/Video/LoopedVimeoPlayer.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Video/Video.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Video/VideoBackground.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Video/VideoControlController.ts");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Video/VimeoBackground.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/Announcement/announcement-section.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/BatterySafetyLogos/BatterySafetyLogos.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/BatteryVoltage/battery-voltage.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/AnnouncementThreeProductSection/announcement-section.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/parts/BlackFridayParts/TariffBlock.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/CookiesBanner/CookiesBanner.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/CustomizationsGalleryCard/customizations-gallery-card.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/AnnouncementSeedlingPromo/announcement-seedling-section.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/(site)/battery-tips-and-tricks/battery-tips-and-tricks.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["CustomizationButton"] */ "/opt/buildhome/repo/src/parts/EuropeanLanderCustomizationSection/CustomizationButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomizationHeader"] */ "/opt/buildhome/repo/src/parts/EuropeanLanderCustomizationSection/CustomizationHeader.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/EuropeanLanderHeroSection/EuropeanLanderHeroSection.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/EuropeanLanderMdrSection/EuropeanLanderMdrSection.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/EUStockedProducts/EUStockedProductsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductGroup"] */ "/opt/buildhome/repo/src/parts/EUStockedProducts/ProductGroup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SingularCard"] */ "/opt/buildhome/repo/src/parts/EUStockedProducts/SingularCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MouthpiecesMobileSlider"] */ "/opt/buildhome/repo/src/parts/MouthpiecesMobileSlider/MouthpiecesMobileSlider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/PowerPulseCard/power-pulse.card.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/ProcessCertifications/ProcessCertifications.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/ProductAutomationSection/product-automation.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/ProductCard/product-card.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/ProductCard/ProductSlider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/ProductOptionsCard/product-options.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/ProductProfile/product-profile.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/ProductsAvailableFromGlobalFacilities/ProductsAvailableFromGlobalFacilities.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/ProductSpecification/ProductSpecification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductXLMouthpieces"] */ "/opt/buildhome/repo/src/parts/ProductXLMouthpieces/ProductXLMouthpieces.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/SectionsNavigation/SectionsNavigation.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/SingularSections/HapticFeedbackCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileSingularSpecifications"] */ "/opt/buildhome/repo/src/parts/SingularSections/MobileSingularSpecifications.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/SingularSections/SeeSingularLaunchTrailer.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/SingularSections/SingularFaqSection/SingularFAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/SingularSections/SingularForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/parts/SingularSections/SingularGetSamplesBannerClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/parts/SingularSections/Sliders/ReusableBatteriesSwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/parts/SingularSections/Sliders/SingularSpecificationsSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SnaptixImageCarouselSlider"] */ "/opt/buildhome/repo/src/parts/SnaptixImageCarousel/SnaptixImageCarouselSlider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/TopBrandsWall/TopBrandsWall.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["XLMouthpiecesMobileSlider"] */ "/opt/buildhome/repo/src/parts/XLMouthpiecesMobileSlider/XLMouthpiecesMobileSlider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/modules/page.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/modules/contactform.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/modules/sample_form.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/modules/directions.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/HeatingCosistency/heating-consistency.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/HeroSection/video-hero-section.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/modules/product_detail.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/PeaceOfMind/peace-of-mind.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/ProductCustomizationsSection/product-customizations-section.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/ProductSpecificationSection/product-specification-section.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/ProductXLMouthpieces/product-xl-mouthpieces.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/modules/testimonials.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/modules/brands.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/ProVapeTips/pro-vape-tips.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/(site)/news/news.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/modules/blog.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/VideoCard/video.card.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/ImageCarousel/image-carousel.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/SnaptixAromaDiscreet/snaptix-aroma-discreet.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/parts/HeroSectionWithVideo/hero-section-with-video.module.scss");
